import { Directive, TemplateRef, AfterViewInit, inject } from '@angular/core';
import { ZefErrorTemplateService } from '../../error-template.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[zefPopErrorOutlet]',
  standalone: false
})
export class PopErrorOutletDirective implements AfterViewInit {

  templateRef = inject(TemplateRef<any>);
  #errorTemplate = inject(ZefErrorTemplateService);

  ngAfterViewInit() {
    this.#errorTemplate.setTemplate(
      this.templateRef,
      'pop'
    );
  }
}
